import React from 'react';

import { StepDetail } from 'screens/MyJourney/details/StepDetail';
import { Description } from 'screens/MyJourney/details/StepDetail';
import styled from 'styled-components';

export const FollowUpGenericDetail = () => {
  return (
    <StepDetail>
      <Description>
        You will receive a call with the results of your pregnancy test. The next steps will be
        discussed with you at this time.
      </Description>
      <NoMargin>As always, contact us with any questions!</NoMargin>
    </StepDetail>
  );
};

const NoMargin = styled.p`
  margin: 0;
`;
